const incPattern = new RegExp('{{__INC__}}', 'g');

const createDisplayList = (template, list, parent) => {
  let result = '';

  if (typeof template === 'string') {
    result = list.reduce((str, data, i) => str + processTemplate(template, data, i), '');
  } else {
    result = list.reduce((str, data, i) => str + processTemplate(template[data.template], data, i), '');
  }

  if ('content' in document.createElement('template')) {
    const el = document.createElement('template');
    el.innerHTML = result;
    parent.appendChild(el.content);
  } else {
    parent.innerHTML = parent.innerHTML + result;
  }
};

const processTemplate = (template, data, i) => {
  const matches = template.match(/(?:\{\{)(.*?)(?:\}\})/g).map((match) => match.replace(/(\{\{|\}\})/g, ''));
  const keys = [...new Set(matches)];
  return keys.reduce((str, key) => {
    if (key === '__INC__') {
      return str.replace(incPattern, i);
    }
    const keyReg = new RegExp(`{{${key}}}`, 'g');
    return str.replace(keyReg, key[0] === '"' ? convertToString(data[key.replace(/\"/g, '')]) : data[key]);
  }, template);
};

const convertToString = (list) => Object.keys(list).reduce((str, prop) => `${str} ${prop}="${list[prop]}" `, '');

const DisplayList = {};
DisplayList.create = createDisplayList;

export default DisplayList;
